export const dechra = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 25,
  inputPaddingInline: 9,

  inputHeight: 30,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 14,
  inputFontFamily: '"Poppins", sans-serif',
  inputColor: "#000000",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#E8E8E8",
  inputBorderWidth: 1,
  inputBorderRadius: 0,

  inputHoverColor: "#000000",
  inputHoverBorderColor: "#E8E8E8",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 25,
  selectPaddingInline: 9,

  selectHeight: 30,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 14,
  selectFontFamily: '"Poppins", sans-serif',
  selectColor: "#000000",
  selectBackgroundColor: "#ffffff",
  selectFontWeight: 400,

  selectBorderColor: "#E8E8E8",
  selectBorderWidth: 1,
  selectBorderRadius: 0,

  selectHoverColor: "#000000",
  selectHoverBorderColor: "E8E8E8",
  selectHoverBackgroundColor: "#ffffff",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 25,
  textAreaPaddingInline: 9,

  textAreaHeight: 30,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 14,
  textAreaFontFamily: '"Poppins", sans-serif',
  textAreaColor: "#000000",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#E8E8E8",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 0,

  textAreaHoverColor: "#000000",
  textAreaHoverBorderColor: "E8E8E8",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#000000",
  placeholderFontFamily: '"Poppins", sans-serif',
  placeholderFontSize: 12,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#000000",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 7,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 14,
  fieldLabelColor: "#000000",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#FF585D",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Poppins", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#000000",
  descriptionFontSize: 12,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Poppins", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 15,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 0,
  checkboxUncheckedBorderColor: "#E8E8E8",
  checkboxUncheckedBackgroundColor: "#ffffff",
  checkboxCheckedBackgroundColor: "#33628D",
  checkboxCheckedBorderColor: "#E8E8E8",
  checkboxCheckedColor: "#ffffff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Poppins", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#000000",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 15,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#E8E8E8",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#33628D",
  radioCheckedBorderColor: "#E8E8E8",

  radioAlignment: "none",

  radioLabelFontFamily: '"Poppins", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 400,
  radioLabelColor: "#000000",

  // **********************************
  // submit button

  submitMarginTop: 25,
  submitFontSize: 20,
  submitFontFamily: "'Poppins', sans-serif",
  submitWidth: 107,
  submitWidthUnits: "px",
  submitHeight: 55,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#33628D",
  submitColor: "#ffffff",
  submitBorderColor: "transparent",
  submitBackgroundHover: "#33628D",
  submitBorderColorHover: "transparent",
  submitColorHover: "#ffffff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 700,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  